// EN/FR copy for the manager's employee evaluation workspace (data-cvi-i18n="managed").

const plural = (n, one, many) => (n === 1 ? one : many);

const COPY = {
    en: {
        title: "Employee Reviews",
        subtitle: "Select an employee to rate their Core Responsibilities and Individual Goals.",
        emptyTitle: "No employees to review",
        emptyDescription: "Your direct reports will appear here.",
        search: "Find an employee",
        searchPlaceholder: "Search by name or position",
        noMatch: query => `No employee matches “${query}”.`,
        count: n => `${n} ${plural(n, "employee", "employees")}`,
        back: "All employees",
        previous: "Previous employee",
        next: "Next employee",
        position: (i, n) => `${i} of ${n}`,
        sections: "Evaluation sections",
        responsibilities: "Core Responsibilities",
        goals: "Individual Goals",
        period: "Period",
        noPeriod: "No active period",
        state: { open: "Open for evaluation", closed: "Closed · read-only", none: "No active period" },
        stateHelp: {
            open: "Ratings and comments are saved as you enter them.",
            closed: "This period is closed. Evaluations can be viewed but not changed.",
            none: "Evaluations open when an administrator activates a period.",
        },
        roles: { specialist: "Employee", manager: "Manager", deputy: "Business Unit Lead", ceo: "Executive" },
        open: name => `Evaluate ${name}`,
    },
    fr: {
        title: "Évaluations des employés",
        subtitle: "Sélectionnez une personne pour évaluer ses responsabilités principales et ses objectifs individuels.",
        emptyTitle: "Aucune personne à évaluer",
        emptyDescription: "Vos subordonnés directs apparaîtront ici.",
        search: "Trouver une personne",
        searchPlaceholder: "Rechercher par nom ou par poste",
        noMatch: query => `Aucune personne ne correspond à «\u00a0${query}\u00a0».`,
        count: n => `${n} ${plural(n, "personne", "personnes")}`,
        back: "Toutes les personnes",
        previous: "Personne précédente",
        next: "Personne suivante",
        position: (i, n) => `${i} sur ${n}`,
        sections: "Sections de l’évaluation",
        responsibilities: "Responsabilités principales",
        goals: "Objectifs individuels",
        period: "Période",
        noPeriod: "Aucune période active",
        state: { open: "Ouverte à l’évaluation", closed: "Fermée · lecture seule", none: "Aucune période active" },
        stateHelp: {
            open: "Les évaluations et les commentaires sont enregistrés au fur et à mesure.",
            closed: "Cette période est fermée. Les évaluations peuvent être consultées, mais pas modifiées.",
            none: "Les évaluations s’ouvrent lorsqu’un administrateur active une période.",
        },
        roles: { specialist: "Employé", manager: "Gestionnaire", deputy: "Responsable d’unité d’affaires", ceo: "Haute direction" },
        open: name => `Évaluer ${name}`,
    },
};

export function evaluationCopy(language) {
    return COPY[language === "fr" ? "fr" : "en"];
}
